import { compose } from 'redux';
import { DetailContainerNew } from '../../common/containers';

import { withResponseHandler } from './helpersDetailContainer';

export const DetailContainer = function (WrappedComponent) {
	return compose(
		DetailContainerNew,
		withResponseHandler,
	)(WrappedComponent);
};
